import {StoreRuleAppType} from '../../../provider/catalogs/catalogs-type';

export type StoreSourceType = {
    id: number;
    name: string;
};

// The review sources are the distinct catalogs of the linked applications themselves: one response
// feeds both selects, so a source without applications cannot appear and the order stays as served.
// The catalog name comes from the catalogs context; the website stands in until that context loads.
// catalogId is a non-null FK on the backend row, so it is always a usable grouping key.
export function getStoreSourcesFromApps(
    storeApps: Array<StoreRuleAppType>,
    getCatalogName: (catalogId?: number) => string
): Array<StoreSourceType> {
    const sourceById = new Map<number, StoreSourceType>();

    storeApps.forEach((app) => {
        if (sourceById.has(app.catalogId)) {
            return;
        }

        sourceById.set(app.catalogId, {id: app.catalogId, name: getCatalogName(app.catalogId) || app.website});
    });

    return [...sourceById.values()];
}
